import { keyMirror } from '@tunein/web-utils';

export const MAC_DESKTOP_OS = 'Macintosh';
export const WINDOWS_DESKTOP_OS = 'Windows';

export const desktopFuncNames = keyMirror(
  // Defined by desktop and called by web app to trigger desktop behaviors
  'quitDesktopAndInstallUpdate',
  'openSocialShare',
  'reloadPage',
  'openfacebookAuth',
  'openGoogleAuth',
  'setUpLocalizations',
  'setUpGeminiEventSender',
  'showOptOutPageMenuItem',
  'hideOptOutPageMenuItem',
  'showGdprSettingsMenuItem',
  'hideGdprSettingsMenuItem',
  'enableMenuPlayPause',
  'setSerial',
  'getSerial',
  'setPartnerId',
  'registerAppHandlers',
  'wasAutoReloaded',
  // Defined by web app and called by desktop to trigger web app behaviors
  'getLocalizedText',
  'handleDesktopPlayToggle',
  'handleDesktopVolumeUp',
  'handleDesktopVolumeDown',
  'handleDesktopHistoryFwd',
  'handleDesktopHistoryBack',
  'handleNavigateToAccount',
  'handleNavigateToOptOutPage',
  'handleOpenGdprSettings',
  'logClientError',
  'handleFacebookDesktopAuthentication',
  'handleDesktopSearch',
  'handleAvailableDesktopUpdate',
  'handleGoogleDesktopAuth',
);
